import { Box, Stack, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

import { appShape } from '../themes/shapeTokens';
import { EditableTitle } from './EditableTitle';

type ViewTitleBarProps = {
	title: string;
	subtitle?: React.ReactNode;
	titleAdornment?: React.ReactNode;
	onTitleChanged?: (title: string) => void;
	children?: React.ReactNode;
	titleTypographySx?: SxProps<Theme>;
};

function ViewTitleBar({ title, subtitle, titleAdornment, onTitleChanged, children, titleTypographySx }: ViewTitleBarProps) {
	return (
		<Stack
			direction={{ xs: 'column', sm: 'row' }}
			justifyContent="space-between"
			alignItems={{ xs: 'stretch', sm: 'center' }}
			m={0}
			p={1}
			sx={{
				borderRadius: appShape.surfaceRadius,
				backgroundColor: 'background.header',
				backgroundImage: 'none',
			}}
		>
			<Box sx={{ flex: '1 1 auto', minWidth: 0, mr: { xs: 0, sm: children ? 2 : 0 }, pl: { xs: 6, sm: 0 } }}>
				<Stack spacing={0.25}>
					<Stack direction="row" alignItems="center" spacing={2} useFlexGap sx={{ flexWrap: 'wrap' }}>
						<Box sx={{ minWidth: 0, maxWidth: '100%', width: titleAdornment ? 'auto' : '100%' }}>
							{onTitleChanged ? (
								<EditableTitle name={title} onNameChanged={onTitleChanged} />
							) : (
								<Typography
									variant="h4"
									color="textSecondary"
									sx={{
										fontSize: { xs: '1.35rem', sm: undefined },
										lineHeight: { xs: 1.3, sm: undefined },
										fontWeight: 600,
										...titleTypographySx,
									}}
								>
									{title}
								</Typography>
							)}
						</Box>
						{titleAdornment}
					</Stack>
					{subtitle && (
						<Typography variant="body2" color="text.secondary">
							{subtitle}
						</Typography>
					)}
				</Stack>
			</Box>
			{children && <Box sx={{ flex: '0 0 auto', alignSelf: { xs: 'flex-end', sm: 'auto' }, mt: { xs: 0.5, sm: 0 } }}>{children}</Box>}
		</Stack>
	);
}

export default ViewTitleBar;
